import styled from "styled-components";
import * as BackgroundStyles from "../../../common/styles/BackgroundStyles";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

/**
 * Shared styles for a "popup list" which contains a clickable list of button options.
 */
export const Wrapper = styled(BackgroundStyles.Shadow)`
    position: absolute;
    right: 0;
    min-width: 256px;
    z-index: ${theme.zIndex.popover};

    html[dir="rtl"] & {
        left: 0;
        right: auto;
    }
`;

export const Button = styled.button`
    width: 100%;
    min-height: 50px;
    margin: 0;
    padding: 0;
    padding-left: ${theme.space[2]}px;
    text-align: start;
    color: ${theme.colors.midnight};
    background: none;
    border: none;
    border-bottom: 1px solid ${theme.colors.silver};

    &:hover,
    &:active,
    &:focus {
        background-color: ${theme.colors.mist};
    }

    html[dir="rtl"] & {
        padding-left: 0;
        padding-right: ${theme.space[2]}px;
    }
`;

export const Item = styled.div``;

export const ItemRow = styled.div`
    &:last-child {
        ${Button} {
            border-bottom: none;
        }
    }
`;
